import styles from './TreatmentsGraph.module.scss'
import api from 'helpers/api'
import { useCallback, useEffect, useState } from 'react'
import { ResponsiveBar } from '@nivo/bar'
import Loader from '../../../miscellaneous/Loader/Loader'
import { FaChartPie } from 'react-icons/fa'

const TreatmentsGraph = ({ dateRange, narrowDownBy }) => {
    const { startDate, endDate } = dateRange;
    const [ data, setData ] = useState(null);
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ keys, setKeys ] = useState([ 'sessions' ]);
    const [ genderKeys, setGenderKeys ] = useState([]);
    const [ ageKeys, setAgeKeys ] = useState([]);

    const getData = async () => {
        const data = await api.get(`dashboard/treatments/areas?startDate=${startDate}&endDate=${endDate}`)

        const keys = {
            'gender': [],
            'age': []
        }

        const realData = [];

        if (data.status === 200 && data.data.data) {
            data.data.data.map(item => {
                const row = {
                    name: item.name,
                    sessions: item.sessions
                };

                if (item.by_gender) {
                    Object.keys(item.by_gender).map((gKey) => {
                        const key = `gender_${gKey}`;
                        const value = item.by_gender[ gKey ];

                        row[ key ] = value;
                        keys.gender.push(key);
                    })
                }

                if (item.by_age) {
                    Object.keys(item.by_age).map((aKey) => {
                        const key = `age_${aKey}`;
                        const value = item.by_age[ aKey ];

                        row[ key ] = value;
                        keys.age.push(key);
                    })
                }

                realData.push(row);
            });
        }

        setAgeKeys([ ...new Set(keys.age) ]);
        setGenderKeys([ ...new Set(keys.gender) ]);

        return realData;
    }

    const getKeys = useCallback(() => {
        if (narrowDownBy === 'gender') {
            return genderKeys;
        } else if (narrowDownBy === 'age') {
            return ageKeys;
        } else {
            return [ 'sessions' ]
        }
    }, [ narrowDownBy, genderKeys, ageKeys ])

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            //console.log(res)
            setData(res)
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        // console.log(getKeys(), narrowDownBy)
        setKeys(getKeys())
    }, [ getKeys ])

    useEffect(() => {
        if (data !== null) {
            setIsLoaded(true)
        }
    }, [ data ])

    return (<div className='d-flex' style={ { width: '100%', height: 300, maxHeight: 340 } }>
        { isLoaded ? <>
            { data !== null && data.length > 0 ? <ResponsiveBar
                data={ data }
                indexBy="name"
                keys={ keys }
                padding={ 0.4 }
                valueScale={ { type: 'linear' } }
                indexScale={ { type: 'band', round: true } }
                axisTop={ null }
                axisRight={ null }
                role="application"
                margin={ { top: 0, right: 0, bottom: 50, left: 0 } }
                labelSkipWidth={ 12 }
                labelSkipHeight={ 12 }
                labelTextColor="#fff"
                colors={ [
                    '#5c9ceb',
                    '#319aa1',
                    '#341f97',
                    '#f7c59f',
                ] }
                tooltipLabel={ ({ id, value, color }) => {
                    let label = 'Total Sessions';

                    if (id.includes("gender_")) {
                        const gender = id.split("_")[ 1 ];
                        label = `${gender.charAt(0).toUpperCase() + gender.slice(1)} Sessions`
                    } else if (id.includes("age_")) {
                        const age = id.split("_")[ 1 ];
                        label = `Age ${age.charAt(0).toUpperCase() + age.slice(1)} Sessions`
                    }

                    return (<>
                        <span style={ { color } }>{ label }</span>
                    </>)
                } }
            /> : <><div className={ `${styles.noData}` }>
                <FaChartPie />
                No data
            </div></> }
        </> : <div style={ { margin: 'auto' } }><Loader color="#ddd"></Loader></div> }
    </div>)
}


export default TreatmentsGraph;